import { getUserStore } from "../store/store";
import { mutatorAction } from "satcheljs";
import type { MailboxInfo } from "owa-client-types";
import type { MailFolderTableQuery } from "owa-mail-list-store";

export const setPreviousTableQueryMutator: (mailboxInfo: MailboxInfo, tableQuery: MailFolderTableQuery | undefined) => void = mutatorAction("setPreviousTableQuery", (mailboxInfo: MailboxInfo, tableQuery: MailFolderTableQuery | undefined): void => {
    const store = getUserStore(mailboxInfo);
    store.previousTableQuery = tableQuery;
});
